import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationModel } from 'common/models/page-models/notification/notification-data.model';
import { NotificationListingModel } from 'common/models/page-models/notification/notification-grid.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { NotificationGridWidgetService } from 'common/widget/notification/notification-grid-widget.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationGridResolver extends GridResolver<NotificationModel, NotificationListingModel> {
    constructor(
        protected fs: NotificationGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
